import { Typography } from "@mui/material";
import helpers from "../hooks/HelperFunctions";
import { CampaignLink } from "./campaignLink";

const TEXT_BASE_STYLE = { fontSize: 12 };

const currencyColumn = (field, headerName, extra = {}) => ({
    field,
    headerName,
    width: 140,
    type: "number",
    renderCell: ({ value }) => (
        <Typography sx={TEXT_BASE_STYLE}>{helpers.formatNumber(value, true)}</Typography>
    ),
    ...extra,
});

export const getRevenueBudgetReportColumns = () => [
    {
        field: "name",
        headerName: "Campaign",
        width: 220,
        renderCell: ({ row }) => <CampaignLink id={row?._id} name={row?.name} />,
    },
    {
        field: "brandName",
        headerName: "Brand",
        width: 160,
        renderCell: ({ row }) => <Typography sx={TEXT_BASE_STYLE}>{row?.brandName || "-"}</Typography>,
    },
    {
        field: "pocName",
        headerName: "POC",
        width: 160,
        renderCell: ({ row }) => <Typography sx={TEXT_BASE_STYLE}>{row?.pocName || "-"}</Typography>,
    },
    currencyColumn("totalPayment", "Budget"),
    currencyColumn("paymentLimit", "Limit"),
    currencyColumn("revenueAmount", "Revenue"),
    // Colored like profileColumns.js's STATUS_COLOR_MAP success/danger pair, so a
    // loss-making campaign (revenue below budget) reads as a warning at a glance.
    currencyColumn("netRevenue", "Net Revenue", {
        renderCell: ({ row }) => (
            <Typography
                sx={{
                    ...TEXT_BASE_STYLE,
                    fontWeight: 600,
                    color: (row?.netRevenue ?? 0) < 0 ? "#DC3545" : "#198754",
                }}
            >
                {helpers.formatNumber(row?.netRevenue, true)}
            </Typography>
        ),
    }),
    {
        field: "revenueLockedDate",
        headerName: "Revenue Locked",
        width: 150,
        renderCell: ({ row }) =>
            row?.revenueLockedDate ? (
                <Typography sx={TEXT_BASE_STYLE}>
                    {new Date(row.revenueLockedDate).toLocaleDateString("en-IN")}
                </Typography>
            ) : (
                <Typography sx={TEXT_BASE_STYLE}>-</Typography>
            ),
    },
];
